export function UiIcon({ Icon, style, ...props }) {
  return (
    <Icon
      size={20}
      strokeWidth={1.5}
      color="currentColor"
      fill="none"
      style={{ display: "inline-block", verticalAlign: "middle", ...style }}
      {...props}
    />
  );
}

export function InlineIcon({ Icon, style, ...props }) {
  return (
    <Icon
      size={16}
      strokeWidth={1.5}
      color="currentColor"
      fill="none"
      style={{ display: "inline-block", verticalAlign: "text-bottom", ...style }}
      {...props}
    />
  );
}
